import { animated, useTransition } from "@react-spring/web";
import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import { getAppConfig } from "../../api/config.ts";
import type { LoadingSpinnerProps } from "../../components";
import { LoadingSpinner } from "../../components";
import styles from "./LoadingAnimation.module.css";

export const LoadingAnimation: FC<
  React.PropsWithChildren<{
    visible: boolean;
  }>
> = ({ visible }) => {
  const transitions = useTransition(visible, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  });

  const configQuery = useQuery({
    queryKey: ["config"],
    queryFn: async () => {
      return getAppConfig();
    },
  });

  return transitions(
    (style, item) =>
      item && (
        <animated.div className={styles.overlay} style={style}>
          <LoadingSpinner
            icon={getContextualIcon({
              league: {
                sport:
                  configQuery.data?.team?.league?.sport?.name?.toLowerCase() ??
                  "unknown",
              },
            })}
            size="5rem"
          />
        </animated.div>
      ),
  );
};

function getContextualIcon(
  config: { league: { sport: string } } | null,
): LoadingSpinnerProps["icon"] | undefined {
  switch (config?.league.sport.toLowerCase()) {
    case "baseball":
      return "Baseball";
    case "basketball":
      return "Basketball";
    case "football":
      return "Football";
    case "hockey":
      return "Hockey";
    case "soccer":
      return "Soccer";
    default:
      return "Loading";
  }
}
